module.exports = __webpack_public_path__ + "img/welcome.44911acb.png";